import { useMemo } from 'react'

export const usePersonalityHero = personality => {
	return useMemo(
		() => ({
			title: personality?.name || '',
			description: personality?.description || '',
			tags: Array.isArray(personality?.tags) ? personality.tags : [],
		}),
		[personality],
	)
}

export default usePersonalityHero

